export default __webpack_public_path__ + "dd4efbea27b700c0109f64f649c2a359.png";